// @ts-nocheck
import React, {useEffect, useState} from 'react';
import {
  FlatList,
  View,
  KeyboardAvoidingView,
  Platform,
  Pressable,
  StyleSheet,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import {
  showErrorMessage,
  showInformationMessage,
  showSuccessMessage,
} from '../../../service/flashMessage';
import {deleteUnitLinkById, unlinkUnitLinkById} from '../../../api/links';
import UnitListitem from '../components/UnitListitem';
import NavbarWithAction from '../../../components/NavbarWithAction';
import MySearchbar from '../../../components/MySearchbar';
import AsterixDialog from '../../../components/AsterixDialog';
import {checkUnitCode} from '../../../api/units';
import {deriveDisplayName} from '../../../utils/deriveDisplayName';
import HStack from '../../../components/HStack';
import {ActivityIndicator} from 'react-native-paper';
import FeatherIcon from '@expo/vector-icons/Feather';
import Select from '../../../components/Select';
import {
  GetUnitScreenData,
  SearchUnits,
  SetDefaultUnitLink,
  SetSwitchingUnits,
} from '../unitsReducer';
import Text from '../../../components/Text';
import {RootStore, store} from '../../../redux/store';
import {createDateFrame, dateFrameRequestAccess, fetchDateFramesByUnit, updatePersonDateFrames} from '../../../api/dataframe';
import {RequestAccess} from '../types';
import {
  DeleteAllApprovals,
  GetApprovals,
} from '../../../redux/reducers/approvalsReducer';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import NoUnits from '../components/NoUnits';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import {
  getCurrentUnitLink,
  isOneDayDateFrame,
  permissionToBool,
  toLocalDateTime,
} from '../../../utils';
import {pasteFromClipboard} from '../../../service/clipboard';
import Container from '../../../components/Container';
import InviteCodeGenerator from '../../More/components/InviteCodeGenerator';
import {DeleteAllAlerts, GetAlerts} from '../../Alerts/alertsReducer';
import isWeb from '../../../utils/isWeb';
import {unitHasPeopleType} from '../api';
import {confirmOneDayDateFrame, showAlert} from '../../../service';
import CreateDateFramePanel from '../../../components/CreateDateFramePanel';
import FormContainer from '../../../components/FormContainer';
import * as RootNavigation from '../../../navigation';
import {showKeyboardAwareAlert} from '../../../utils/keyboard';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

const UnitList = ({navigation, hasDrawer = false}) => {
  const insets = useSafeAreaInsets();
  const unitsAndLinks = useSelector(
    (state: RootStore) => state.units.unitLinks,
  );
  const currentUnitPeopleLink = getCurrentUnitLink();
  const [searchTerm, setSearchTerm] = useState('');
  const isLoading = useSelector((state: RootStore) => state.units.loading);

  const dispatch = useDispatch();
  const personId = useSelector(
    (allState: RootStore) => allState?.auth?.user?.id,
  );
  const [isNavbarShown, setIsNavbarShown] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [linkCodeEntry, setLinkCodeEntry] = useState('');
  const isSwitching = useSelector(
    (state: RootStore) => state.units,
  )?.isSwitching;
  const [showInviteCodeModal, setShowInviteCodeModal] = useState(false);
  const listBottomPadding = insets.bottom + (Platform.OS === 'ios' ? 144 : 120);

  const onClickGenerateInviteCode = () => {
    setShowInviteCodeModal(true);
  };

  const checkUnitCodeValidity = async () => {
    try {
      const unit = await checkUnitCode(linkCodeEntry);
      navigation.navigate('People In Unit', {
        unit,
        unitCode: linkCodeEntry,
        unitName: unit.unit ? unit.unit : unit.unitDisplay,
      });
    } catch (error) {
      showErrorMessage(
        'UnitList: We couldn\'t find that unit code. Unit codes are case sensitive. Please try again',
      );
    }
  };

  useEffect(() => {
    // On initial mount: check if we have cached units
    // If yes, use cache (warm start optimization)
    // If no, fetch fresh data (cold start or first load)
    dispatch(GetUnitScreenData(false)); // false = use cache if available
  }, []);

  useEffect(() => {
    // Refetch alerts when units count change
    dispatch(DeleteAllAlerts());
    dispatch(GetAlerts());
    dispatch(GetApprovals());
  }, [unitsAndLinks.length]);

  useEffect(() => {
    // Auto-select unit when exactly 1 unit is available and it's newly added
    if (unitsAndLinks.length === 1 && !isLoading) {
      const unit = unitsAndLinks[0];
      // Use setTimeout to allow navigation to be ready
      setTimeout(() => {
        selectUnitHandler(
          unit.id,
          unit.unit.id,
          unit.unit.status,
          unit.peopleType.id,
          unit.peopleType.name?.toLowerCase().includes('owner'),
          true, // isAutoSelected = true
        );
      }, 500);
    }
  }, [unitsAndLinks.length]);

  const showRemoveSelfPrompt = (id: string) => {
    showKeyboardAwareAlert(
      '',
      'Do you really want to exit this unit ?',
      [
        {
          text: 'NO',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          text: 'YES',
          onPress: () => unlinkFromUnit(id),
        },
      ],
      {
        cancelable: true,
      },
    );
  };

  const unlinkFromUnit = async (id: string) => {
    try {
      // TODO unlink person from unit
      await unlinkUnitLinkById(id);
      showSuccessMessage('You unlinked from the unit successfully');
    } catch (error) {
      showErrorMessage('UnitList - 2: ' + error.message);
    }
    // Force refresh after unlinking since state changed on backend
    dispatch(GetUnitScreenData(true));
  };

  const sendAccessRequest = async (request: RequestAccess) => {
    const shouldContinue = await confirmOneDayDateFrame(
      request.startDate,
      request.endDate,
    );

    if (!shouldContinue) {
      return;
    }

    try {
      await dateFrameRequestAccess({
        unitId: request.unitId,
        startDate: request.startDate,
        endDate: request.endDate,
        description: request.description,
      });
      showSuccessMessage('Request sent, you will be notified when accepted.');
      //Update requesters approvals list to include the newly created approval.
      setTimeout(() => {
        //@ts-ignore
        store.dispatch(DeleteAllApprovals());
        //@ts-ignore
        store.dispatch(GetApprovals());
      }, 2000);
    } catch (error) {
      showErrorMessage('UnitList - 3: ' + error.message);
    }
  };

  const fetchCopiedText = async () => {
    const text = await pasteFromClipboard();
    setLinkCodeEntry(text);
  };

  const copyToClipBoard = text => {
    copyToClipBoard(text);
    showSuccessMessage('Code copied to clipboard');
  };

  const renderHeader = () => {
    return (
      <>
        {isNavbarShown ? (
          <NavbarWithAction
            hasAdd={true}
            hasSearch={unitsAndLinks.length > 1}
            //TODO: Perform a search in a different screen
            // and pass the results to this screen ? No
            // Problem is maintaining the default unit during search
            onClickSearch={() => setIsNavbarShown(false)}
            onClickAdd={() => navigation.navigate('Add with UnitCode')}
            title="Select unit"
            hasMoreMenu
            hasSignOut
            navigation={navigation}
            hasAccessCard={!!currentUnitPeopleLink}
            onClickAccessCard={() =>
              navigation.navigate(E_NAVIGATION_DESTINATIONS.ID_CARD)
            }
            fullScreen
            hasProfile
            openProfile={() => navigation.navigate('Edit Profile')}
            hasGenerateInviteCode
            onClickGenerateInviteCode={onClickGenerateInviteCode}
            hasOthers
            openOthers={() => navigation.navigate('Others')}
          />
        ) : (
          <MySearchbar
            placeholder="Search by nickname or unit name"
            setValue={val => {
              setSearchTerm(val?.trim());
              dispatch(SearchUnits(val?.trim()));
            }}
            resetSearch={() => {
              setIsNavbarShown(true);
              setSearchTerm('');
              dispatch(SearchUnits(''));
            }}
          />
        )}
      </>
    );
  };

  const selectUnitHandler = async (
    unitLinkId,
    unitId: string,
    unitStatus: string,
    peopleTypeId: string,
    isOwner,
    isAutoSelected: boolean = false,
  ) => {
    dispatch(SetSwitchingUnits(true));
    // For owners and owner residents
    if (isOwner && unitStatus?.toLowerCase().includes('rented')) {
      const tenantId = '272536A1-9380-4926-88DE-8C7D6F051156';
      const unitHasTenant = await unitHasPeopleType(unitId, tenantId);

      if (unitHasTenant) {
        showKeyboardAwareAlert(
          'Warning',
          'This is a rented unit with a Tenant in it. You cannot switch to this unit',
          [
            {
              text: 'OK',
              onPress: () => {
                dispatch(SetSwitchingUnits(false));
              },
            },
          ],
        );

        return;
      } else {
        showKeyboardAwareAlert(
          'Warning',
          'This is a rented unit with no tenant in it. You may manage it until a tenant is added.',
          [
            {
              text: 'Cancel',
              onPress: () => {
                dispatch(SetSwitchingUnits(false));
              },
            },
            {
              text: 'Continue',
              onPress: () => {
                dispatch(SetDefaultUnitLink(unitLinkId));
                dispatch(SetSwitchingUnits(false));

               // Auto-selected units always navigate to Dashboard for better UX
               if (isAutoSelected) {
                 navigation.navigate('Dashboard');
                 return;
               }
               if (isWeb) {
                 RootNavigation.navigateToAlertsTab('Notifications');
                 return;
               }
               navigation.navigate('Dashboard');
              },
            },
          ],
        );
        return;
      }
    }
    setTimeout(() => {
      dispatch(SetDefaultUnitLink(unitLinkId));
      // Auto-selected units always navigate to Dashboard for better UX
      if (isAutoSelected) {
        navigation.navigate('Dashboard');
        return;
      }
      if (isWeb) {
        RootNavigation.navigateToAlertsTab('Notifications');
        return;
      }
      navigation.navigate('Dashboard');
    }, 100);
  };

  const [dateFrames, setDateFrames] = useState<Array<CalendarDateFrame>>([]);
   const [markedDates, setmarkedDates] = useState({});
   const [_modalVisible, _setModalVisible] = useState(false);
   const [selectedDateFrame, setSelectedDateFrame] = useState('');
   const [panelActive, setPanelActive] = useState(false);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [hasForeverDateframe, setHasForeverDateFrame] = useState(true);
   const [editMode, setEditMode] = React.useState(false);
   const [editModeInitialState, setEditModeInitialState] = React.useState(null);
   const [loadingUnitDateFrames, setLoadingUnitDateFrames] = useState(false);
   const [unitDateFrames, setUnitDateFrames] = useState<Array<DateFrame> | []>(
     [],
   );
   const [loadingToday, setLoadingToday] = useState(false);
   const [loadingTommorow, setLoadingTommorow] = useState(false);
   const [allowedInToday, setAllowedInToday] = useState(false);
   const [allowedInTommorow, setAllowedInTommorow] = useState(false);
   const [unitId, setUnitId] = useState(null);
   const [unitPeopleLinkId, setUnitPeopleLinkId] = useState(null);
   const isLoggedInUser = useSelector(
     (allState: RootStore) => allState?.auth?.user?.id === personId,
   );

   useEffect(() => {
    if (unitId) {
      fetchUnitDateFrames(unitId);
    }
  }, [unitId]);

    const fetchUnitDateFrames = async (unitId: string) => {
    setLoadingUnitDateFrames(true);
    try {
      const res = await fetchDateFramesByUnit(1, unitId);
      setUnitDateFrames(res);
    } catch (error) {
      showErrorMessage('UnitCalendar - 2: ' + error.message);
    } finally {
      setLoadingUnitDateFrames(false);
    }
  };

    const handleSubmit = async () => {
    setIsSubmitting(true);
    const dateframeExists = dateFrames.find(
      item => item.dateFrame.id === selectedDateFrame,
    );
    if (dateframeExists) {
      showInformationMessage('Person already added to this dateframe.');
      setIsSubmitting(false);
      return;
    }
    const dateFrame = unitDateFrames.find(
      // @ts-ignore
      item => item?.id === selectedDateFrame,
    );

    const dateframeData = {
      unitId,
      startDate: toLocalDateTime(new Date(dateFrame.startDate), true),
      endDate: toLocalDateTime(new Date(dateFrame.endDate), false),
      description: dateFrame.shortDescription,
    };

    const shouldContinue = await confirmOneDayDateFrame(
      dateframeData.startDate,
      dateframeData.endDate,
    );

    if (!shouldContinue) {
      setIsSubmitting(false);
      return;
    }

    try {
      if (isLoggedInUser) {
        await dateFrameRequestAccess(dateframeData);
      } else {
        const newDateFrame = await createDateFrame(dateframeData);
        const dateFrameObj = {
          unitPeopleLinkId,
          description: dateFrame.shortDescription,
          dateFrameIds: [newDateFrame?.id],
          oneTimePass: isOneDayDateFrame(
            dateframeData.startDate,
            dateframeData.endDate,
          ),
        };
        await updatePersonDateFrames(dateFrameObj);
      }
      showSuccessMessage('Dateframe added successfully');
      _setModalVisible(false);
      // navigation.goBack();
    } catch (error) {
      showErrorMessage('UnitCalendar - 3: ' + error.message);
    } finally {
      setIsSubmitting(false);
      // Reset state
      setSelectedDateFrame('');
      // setUnitId(null);
      setUnitPeopleLinkId(null);
    }
  };

  return (
    <Container hasDrawer={hasDrawer}>
      {renderHeader()}
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        enabled
        keyboardVerticalOffset={10}
        style={{
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <FlatList
          data={unitsAndLinks}
          contentContainerStyle={{
            paddingTop: 24,
            paddingBottom: listBottomPadding,
          }}
          showsVerticalScrollIndicator={false}
          renderItem={({item}) => (
            <UnitListitem
              unitPeopleLink={item}
              onSelectRemoveSelf={() => showRemoveSelfPrompt(item.id)}
              onSelectUnitCode={() => onSelectUnitCode('ZQ84RAP0')}
              selectUnitHandler={() => {
                selectUnitHandler(
                  item.id,
                  item.unit.id,
                  item.unit.status,
                  item.peopleType.id,
                  item.peopleType.name?.toLowerCase().includes('owner'),
                );
              }}
              onOpenCalendar={() => {
                navigation.navigate('Unit Calendar', {
                  unitId: item.unit.id,
                  unitPeopleLinkId: item.id,
                  isLoggedInUser: item.person.id === personId,
                  personId: item.person.id,
                  personName: deriveDisplayName(item.person),
                  unitName: item.unitNickname
                    ? item.unitNickname
                    : item.unit.unitName,
                  allowedToday: item.dateFrameDay.allowedToday,
                  allowedTomorrow: item.dateFrameDay.allowedTomorrow,
                });
              }}
              onSelectDay={request => sendAccessRequest(request)}
              onSelectCustom={() => {
                setUnitId(item.unit.id);
                setUnitPeopleLinkId(item.id);
                _setModalVisible(true);
              }
              }
              onClickApprovalsRequired={() => {
                navigation.navigate('Approvals History', {
                  personName: `${deriveDisplayName(item)}`,
                  isLoggedInUser: true,
                  approvals: item.approvals,
                  type: 'pending',
                  recordName: item.unitNickname
                    ? item.unitNickname
                    : item.unit.unitName,
                });
              }}
              onOpenPermissions={() => {
                navigation.navigate('User Permissions', {
                  isLoggedInUser: true,
                  unitPeopleLink: item,
                  canEditOtherPeoplePermissions: item.canManagePeople,
                  canEditOwnPermissions: item.canEditSelf,
                });
              }}
              onSelectEditUnitLink={() =>
                navigation.navigate('Edit Person Link', {
                  unitLink: item,
                })
              }
              onSelectEditOwnUnitLink={() => {
                navigation.navigate(
                  E_NAVIGATION_DESTINATIONS.EDIT_OWN_UNITLINK,
                  {
                    unitPeopleLink: item,
                    from: 'UNITS',
                  },
                );
              }}
              onSelectEditUnit={() => {
                if (permissionToBool(item?.unitPermission?.charAt(1))) {
                  navigation.navigate('Edit Unit', {
                    unit: item.unit,
                  });
                }
              }}
              rented={item.unit.status?.toLowerCase().includes('rented')}
              disabledForOwner={
                item.unit.status?.toLowerCase().includes('rented') &&
                item.personType?.toLowerCase().includes('owner')
              }
            />
          )}
          ListEmptyComponent={
            <NoUnits
              searchMode={!!searchTerm}
              isLoading={isLoading}
              handleUnitCode={() => navigation.navigate('Add with UnitCode')}
              handlePeopleCode={() => setShowInviteCodeModal(true)}
            />
          }
          refreshing={isLoading}
          onRefresh={() => {
            if (!!searchTerm) {
              dispatch(SearchUnits(searchTerm));
            } else {
              dispatch(GetUnitScreenData(true));
            }
          }}
        />
      </KeyboardAvoidingView>
      <Modal isOpen={modalVisible} onClose={setModalVisible}>
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Enter unit Link Code</Modal.Header>
          <Modal.Body>
            <Input
              mt={4}
              mb={4}
              placeholder="ZQ84RAP0"
              value={linkCodeEntry}
              onChangeText={text => setLinkCodeEntry(text)}
              InputLeftElement={
                <Button
                  variant="ghost"
                  startIcon={
                    <MaterialCommunityIcons
                      name="content-paste"
                      color="gray"
                      size={24}
                    />
                  }
                  onPress={fetchCopiedText}
                />
              }
              InputRightElement={
                <Button
                  variant="link"
                  onPress={() => {
                    setModalVisible(!modalVisible);
                    checkUnitCodeValidity();
                  }}>
                  Continue
                </Button>
              }
            />
          </Modal.Body>
        </Modal.Content>
      </Modal>
      <AsterixDialog
        message={
          isSwitching ? 'Gathering unit information ...' : 'Loading units ...'
        }
        isSwitching={isSwitching || isLoading}
      />
      <InviteCodeGenerator
        modalVisible={showInviteCodeModal}
        closeModal={() => setShowInviteCodeModal(false)}
      />
       {_modalVisible && (
        <View style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          justifyContent: 'center',
          alignItems: 'center',
          // zIndex: 1000,
        }}>
          <View style={{
            backgroundColor: '#fff',
            borderRadius: 6,
            padding: 24,
            minWidth: 320,
            maxWidth: 400,
            minHeight: 260,
            width: '90%',
            elevation: 5,
          }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text style={{ fontWeight: 'bold', fontSize: 18 }}>Link dateframe to person</Text>
              <Pressable onPress={() => _setModalVisible(false)}>
                <FeatherIcon name="x" size={24} color="gray" />
              </Pressable>
            </View>
            <FormContainer style={{ marginTop: 20, }}>
              <Text style={styles.modalText}>
                Select a Date frame or create a new one
              </Text>
              <HStack style={styles.hStack}>
                {loadingUnitDateFrames ? (
                  <HStack>
                    <ActivityIndicator size="small" />
                    <Text style={styles.loadingText}>
                      Loading dateframes...
                    </Text>
                  </HStack>
                ) : (
                  <Select
                    placeholder="Select dateframe"
                    py="1.5"
                    minWidth={200}
                    selectedValue={selectedDateFrame}
                    onValueChange={val => {
                      setSelectedDateFrame(val);
                    }}
                  >
                    {unitDateFrames.map((item: DateFrame) => (
                      <Select.Item
                        label={`${item.shortDescription}(${new Date(item.startDate).toLocaleDateString()} to ${new Date(item.endDate).toLocaleDateString()})`}
                        value={item.id}
                        key={item.id}
                      />
                    ))}
                  </Select>
                )}
                <Button
                  style={{ flex: 1, }}
                  ml={3}
                  py={1}
                  leftIcon={<FeatherIcon name="plus" size={20} />}
                  onPress={() => {
                    _setModalVisible(false);
                    setPanelActive(true);
                  }}
                  variant="outline">
                  Create new
                </Button>
              </HStack>
              <Button
                isDisabled={isSubmitting || !selectedDateFrame}
                my="4"
                py="4"
                onPress={handleSubmit}>
                Submit
              </Button>
            </FormContainer>
          </View>
        </View>
      )}
      <CreateDateFramePanel
        editMode={editMode}
        initialState={editModeInitialState}
        unitId={unitId}
        unitPeopleLinkId={unitPeopleLinkId}
        navigation={navigation}
        panelActive={panelActive}
        setPanelActive={(state: boolean) => setPanelActive(state)}
        onSubmitSuccess={() => {}}
        isLoggedInUser={isLoggedInUser}
      />
    </Container>
  );
};

const styles = StyleSheet.create({
  headerText: {
    marginTop: 16,
    padding: 8,
    fontSize: 16,
  },
  modalText: {
    // marginBottom: 8,
    marginTop: 8,
    // flex: 1,
  },
  hStack: {
    // flex: 1,
    marginTop: 12,
    marginBottom: 24
  },
  loadingText: {
    fontSize: 12,
    marginTop: 12,
    marginLeft: 12,
  },
  card: {
    borderRadius: 8,
    marginVertical: 8,
    padding: 8,
    marginHorizontal: 8,
  },
  cardContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dateFrameTitle: {
    fontSize: 18,
  },
  dateFrameDates: {
    fontSize: 12,
  },
  menuTrigger: {
    paddingLeft: 16,
    paddingTop: 8,
  },
});


export default UnitList;
